import api from '@app/services/api';
import type { ApiError, UserListParams, UserListResponse } from '@app/services/api.types';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

type QueryOptions = Omit<UseQueryOptions<UserListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchUserList = async (params: UserListParams): Promise<UserListResponse> => {
	const url = apiEndpoints.users.getList(params);
	const response = await api.get(url);
	return response?.data?.data;
};

const useUserList = (params: UserListParams, options?: QueryOptions) => {
	return useQuery<UserListResponse, ApiError>({
		queryKey: ['user', 'list', params],
		queryFn: () => fetchUserList(params),
		...options,
	});
};

export default useUserList;
